import { FC } from 'react'
import { PropertyRecordsIcon } from 'src/components/insights/icons/property-records'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { ParcelWidget } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/parcel'
import { ParcelBuildingLotAndLocationWidget } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/building-and-lot'
import { ParcelPropertySalesWidget } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/property-sales'
import { ParcelPropertyDebtsWidget } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/property-debts'
import { ParcelPropertyTaxesWidget } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/property-taxes'
import { ParcelPossibleOwnersWidget } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/possible-owners'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import { Colors } from 'src/components/theme'

const PropertyRecordsInsight: FC<InsightComponentProps> = ({ insight }) => {
  return (
    <InsightContainer insight={insight} color={Colors.primaryGreen700} iconBgColor={Colors.primaryGreen50}>
      <ParcelWidget />
      <ParcelBuildingLotAndLocationWidget />
      <ParcelPossibleOwnersWidget />
      <ParcelPropertySalesWidget />
      <ParcelPropertyDebtsWidget />
      <ParcelPropertyTaxesWidget />
    </InsightContainer>
  )
}

export const PropertyRecords: Insight = {
  id: 'parcel-property-records',
  tabId: COMMANDAI_IDS_MAP.ownerReveal['parcel-property-records-tab'],
  component: PropertyRecordsInsight,
  name: 'Property Records',
  icon: PropertyRecordsIcon,
  linkTooltipFile: 'property-records',
  supportedResultTypes: ['parcel'],
}
